var _defs, _g, _tspan, _tspan2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoPendingUsers({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    x: "0px",
    y: "0px",
    viewBox: "0 0 500 500",
    style: {
      enableBackground: "new 0 0 500 500"
    },
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), /*#__PURE__*/React.createElement("g", {
    id: "BACKGROUND"
  }, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "rgba(235, 222, 222, 0)"
    },
    width: 500,
    height: 500
  })), /*#__PURE__*/React.createElement("g", {
    id: "OBJECTS",
    transform: "matrix(1, 0, 0, 1, 2.868069, -66.921608)"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", null)), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C96750"
    },
    d: "M48.682,159.068c0,0-15.325-24.69-11.761-26.591c3.564-1.901,14.97,13.295,14.97,13.295 L48.682,159.068z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C96750"
    },
    d: "M98.583,178.767c-0.105-0.362-2.854-15.351-13.666-21.989c-7.455-4.576-9.207-19.699-15.845-19.485 c-6.638,0.214-0.214,20.861,10.063,28.095C89.413,172.623,98.583,178.767,98.583,178.767z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C96750"
    },
    d: "M401.417,178.767c0.105-0.362,2.854-15.351,13.666-21.989c7.455-4.576,9.207-19.699,15.845-19.485 c6.638,0.214,0.214,20.861-10.063,28.095C410.587,172.623,401.417,178.767,401.417,178.767z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C96750"
    },
    d: "M451.318,159.068c0,0,15.325-24.69,11.761-26.591c-3.564-1.901-14.97,13.295-14.97,13.295 L451.318,159.068z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#000000"
    },
    d: "M312.768,395.97L312.768,395.97c-37.51,26.201-87.387,26.201-124.897,0l0,0 C162.92,418.782,178.96,500,178.96,500h67.723v-14.921h3.637h3.637V500h67.723C321.679,500,337.719,418.782,312.768,395.97z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C96750"
    },
    d: "M209.079,159.105c5.103,6.856,6.582,18.382,0.903,22.519c-5.679,4.136-16.366-0.683-21.469-7.539 c-5.103-6.856-4.636-15.768,1.043-19.904C195.235,150.044,203.975,152.249,209.079,159.105z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#000000"
    },
    d: "M206.281,173.35c-0.319-0.971-0.896-1.89-1.496-2.706c-1.489-2.023-3.494-3.623-5.75-4.716 c-1.861-0.901-3.855-1.464-5.895-1.781c-0.476-0.074-0.681,0.655-0.201,0.729c4.926,0.765,9.867,3.216,12.229,7.811 c0.17,0.331,0.28,0.549,0.384,0.865C205.703,174.011,206.434,173.814,206.281,173.35L206.281,173.35z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C96750"
    },
    d: "M292.718,159.105c-5.103,6.856-6.582,18.382-0.903,22.519c5.679,4.136,16.366-0.683,21.469-7.539 c5.103-6.856,4.636-15.768-1.043-19.904C306.562,150.044,297.822,152.249,292.718,159.105z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#000000"
    },
    d: "M296.245,173.551c0.987-3.005,4.019-5.559,6.828-6.935c1.82-0.892,3.788-1.43,5.785-1.74 c0.479-0.074,0.276-0.803-0.201-0.729c-5.113,0.795-10.259,3.414-12.695,8.185c-0.167,0.328-0.331,0.668-0.447,1.019 C295.364,173.813,296.094,174.012,296.245,173.551L296.245,173.551z"
  })))), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#DD7C5F"
    },
    d: "M272.876,229.504v-42.643l-22.557,8.801l-22.557-8.801v42.643l-25.13-5.642 c10.087,35.536,47.687,28.199,47.687,28.199s37.599,7.336,47.686-28.199L272.876,229.504z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#000000"
    },
    d: "M272.876,219v-32.139l-22.557,8.801l-22.557-8.801v33.005c3.007,2.845,12.054,9.706,22.557,10.539 C259.131,231.105,269.517,222.377,272.876,219z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C96750"
    },
    d: "M103.592,298.83c0,0,62.359-74.739,99.041-74.969l-16.048,58.92c0,0-57.695,61.814-95.104,61.814 L103.592,298.83z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#DD7C5F"
    },
    cx: 249.658,
    cy: 156.434,
    rx: 48.171,
    ry: 65.227
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#00AB65"
    },
    d: "M122.979,277.511c-0.068,2.215,0.022,4.421,0.291,6.57c3.22,16.1,10.471,27.665,20.805,36.589 c23.375-17.389,42.51-37.888,42.51-37.888l16.048-58.92C178.879,224.01,144.362,255.401,122.979,277.511z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C96750"
    },
    d: "M397.047,298.83c0,0-62.359-74.739-99.041-74.969l16.048,58.92c0,0,57.695,61.814,95.104,61.814 L397.047,298.83z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#00AB65"
    },
    d: "M321.085,398.483c0,0,0.23-26.651-1.528-52.195c-1.726-25.067,7.795-69.466,4.126-82.764 c-3.668-13.297-25.677-39.662-25.677-39.662l-14.558,3.269c0,0-0.573,24.931-33.128,24.931c-32.555,0-33.129-24.931-33.129-24.931 l-14.558-3.269c0,0-22.009,26.365-25.677,39.662c-3.668,13.297,5.853,57.697,4.127,82.764 c-1.759,25.544-1.529,52.195-1.529,52.195c-11.31-2.751-11.769,11.31-11.769,11.31c5.881,13.286,24.797,20.882,43.037,25.195 c25.949,6.136,53.046,6.136,78.994,0c18.241-4.314,37.157-11.909,43.037-25.195C332.854,409.793,332.395,395.732,321.085,398.483z "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#00AB65"
    },
    d: "M377.66,277.511c0.068,2.215-0.022,4.421-0.291,6.57c-3.22,16.1-10.471,27.665-20.805,36.589 c-23.375-17.389-42.509-37.888-42.509-37.888l-16.048-58.92C321.76,224.01,356.277,255.401,377.66,277.511z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#DD7C5F"
    },
    d: "M96.255,171.708c-8.712-10.699-40.503-18.647-40.503-18.647s-3.974-27.817-9.476-28.123 c-5.502-0.306,0,33.319,1.834,36.376c1.81,3.016,30.389,27.893,31.144,28.55c-0.187,3.185-1.137,18.314-3.174,33.996 c-2.293,17.653-10.087,68.091-2.293,98.812c7.795,30.721,22.468,20.175,22.468,20.175c35.312-32.222,2.644-144.732,0.154-153.094 C97.521,188.695,104.283,181.567,96.255,171.708z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#DD7C5F"
    },
    d: "M454.363,124.642c-5.502,0.306-9.476,28.123-9.476,28.123s-31.791,7.948-40.503,18.647 c-8.211,10.083-0.948,17.313-0.084,18.112c-1.867,6.227-35.597,120.767,0.084,153.325c0,0,14.673,10.546,22.468-20.175 c7.795-30.721,0-81.159-2.293-98.812c-2.106-16.215-3.051-31.839-3.191-34.279c0.411-0.358,29.339-25.53,31.161-28.565 C454.363,157.961,459.865,124.336,454.363,124.642z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#000000"
    },
    d: "M255.207,147.416c0,7.542,0,15.084,0,22.626c0,1.06,0,2.12,0,3.18 c0.121-0.159,0.242-0.317,0.362-0.476c-2.36,0.456-4.72,0.912-7.08,1.368c-0.623,0.12-0.359,1.072,0.262,0.952 c2.36-0.456,4.72-0.912,7.08-1.368c0.21-0.041,0.362-0.272,0.362-0.476c0-7.542,0-15.084,0-22.626c0-1.06,0-2.12,0-3.18 C256.194,146.781,255.207,146.78,255.207,147.416L255.207,147.416z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BE5840"
    },
    d: "M229.591,178.293c0,4.987-4.685,9.031-10.463,9.031c-5.778,0-10.463-4.043-10.463-9.031 c0-4.988,4.684-9.031,10.463-9.031C224.906,169.262,229.591,173.305,229.591,178.293z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BE5840"
    },
    d: "M289.613,178.293c0,4.987-4.685,9.031-10.463,9.031c-5.779,0-10.463-4.043-10.463-9.031 c0-4.988,4.684-9.031,10.463-9.031C284.928,169.262,289.613,173.305,289.613,178.293z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#000000"
    },
    d: "M221.734,143.546c0.387,2.007,4.224,1.007,9.02,0.101c4.796-0.907,8.735-1.376,8.347-3.383 c-0.388-2.007-4.59-2.899-9.386-1.993C224.919,139.177,221.346,141.538,221.734,143.546z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#000000"
    },
    d: "M261.768,138.769c-0.397,2.005,3.54,2.492,8.332,3.421c4.792,0.928,8.623,1.945,9.02-0.06 c0.397-2.006-3.165-4.383-7.957-5.311C266.371,135.891,262.165,136.764,261.768,138.769z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#000000"
    },
    d: "M230.416,161.081c0,3.06,1.492,5.541,3.332,5.541c1.84,0,3.332-2.481,3.332-5.541 c0-3.06-1.492-5.541-3.332-5.541C231.908,155.54,230.416,158.021,230.416,161.081z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#000000"
    },
    d: "M264.534,161.081c0,3.06,1.492,5.541,3.332,5.541c1.84,0,3.332-2.481,3.332-5.541 c0-3.06-1.492-5.541-3.332-5.541C266.026,155.54,264.534,158.021,264.534,161.081z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#000000"
    },
    d: "M263.358,193.658c-1.012-2.756-3.752-4.782-6.426-5.71c-4.654-1.616-10.944-0.989-14.32,2.918 c-0.693,0.802-1.344,1.763-1.647,2.792c-0.18,0.611,0.773,0.871,0.952,0.262c0.706-2.398,3.103-4.22,5.347-5.021 c4.448-1.587,10.316-0.863,13.62,2.725c0.586,0.637,1.281,1.633,1.524,2.296C262.623,194.512,263.577,194.256,263.358,193.658 L263.358,193.658z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#000000"
    },
    d: "M184.721,403.525c2.019,1.442,4.196,2.69,6.361,3.894c5.631,3.132,11.532,5.787,17.574,8.019 c19.285,7.126,40.207,9.739,60.619,7.057c15.251-2.004,29.958-6.911,43.596-13.98c0.564-0.293,0.066-1.145-0.498-0.852 c-22.636,11.733-48.098,17.013-73.492,14.05c-15.993-1.866-31.763-6.776-45.951-14.408c-2.63-1.415-5.277-2.893-7.712-4.632 C184.702,402.303,184.208,403.159,184.721,403.525L184.721,403.525z"
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#000000"
    },
    d: "M194.972,152.154c0,0-0.783,27.171,10.288,31.002l8.362-63.067c0,0,38.407,16.04,40.189-9.624 c0,0,2.495,10.515,7.842,9.445c5.346-1.069,2.881-10.337,2.881-10.337s13.024,28.728,32.25,30.315l-1.909,43.267 c0,0,8.718-19.82,5.392-52.612c0,0,17.584-2.852,6.416-29.941c-10.868-26.362-77.809-47.098-115.959,12.688 c-2.239,3.509-3.343,7.63-3.148,11.789C187.886,131.707,189.363,142.287,194.972,152.154z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#000000"
    },
    d: "M272.527,257.8c-2.384,2.015-5.277,3.571-8.114,4.827c-6.305,2.792-13.394,3.862-20.176,2.369 c-5.301-1.167-10.105-3.793-14.297-7.196c-0.489-0.397-1.192,0.297-0.698,0.698c6.908,5.606,15.35,8.883,24.319,8.029 c5.907-0.562,11.637-2.703,16.636-5.871c1.043-0.661,2.083-1.36,3.028-2.158C273.711,258.087,273.01,257.392,272.527,257.8 L272.527,257.8z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#000000"
    },
    d: "M91.733,167.03c-8.08-5.621-17.799-9.012-27.122-11.937c-1.717-0.539-3.442-1.054-5.173-1.545 c-1.015-0.288-2.078-0.687-3.123-0.852c-0.04-0.006-0.408-0.136-0.427-0.11c0.327-0.442,0.278,0.879,0.284-0.048 c0.006-0.849-0.28-1.794-0.421-2.63c-1.154-6.866-2.412-14.023-5.145-20.461c-0.728-1.715-1.938-4.675-4.101-4.976 c-1.922-0.268-2.531,2.115-2.777,3.554c-0.527,3.094-0.364,6.321-0.159,9.436c0.253,3.854,0.718,7.696,1.299,11.514 c0.493,3.241,1.047,6.491,1.848,9.672c0.381,1.514,0.754,2.791,1.804,3.959c4.324,4.808,9.422,9.029,14.227,13.338 c4.934,4.425,9.904,8.809,14.896,13.169c0.38,0.332,0.909,0.661,1.219,1.063c-0.127-0.164-0.012-0.243-0.121,0.027 c-0.092,0.229-0.038,0.633-0.054,0.88c-0.053,0.841-0.108,1.682-0.165,2.523c-0.384,5.615-0.853,11.225-1.409,16.826 c-1.22,12.302-3.12,24.518-4.511,36.8c-0.412,3.635-0.788,7.274-1.125,10.917c-0.059,0.632,0.929,0.628,0.987,0 c0.961-10.384,2.293-20.722,3.681-31.055c1.369-10.196,2.409-20.43,3.165-30.69c0.115-1.561,0.224-3.123,0.324-4.685 c0.042-0.656,0.315-1.699-0.085-2.249c-0.668-0.92-1.945-1.697-2.794-2.441c-4.325-3.788-8.635-7.594-12.917-11.43 c-4.339-3.887-8.707-7.766-12.85-11.864c-0.863-0.854-2.014-1.771-2.563-2.881c-0.733-1.484-0.985-3.336-1.322-4.937 c-1.26-5.988-2.115-12.104-2.532-18.209c-0.186-2.73-0.308-5.501-0.045-8.23c0.094-0.972,0.228-3.691,1.498-4.025 c1.5-0.395,2.775,2.44,3.241,3.408c1.265,2.631,2.078,5.491,2.815,8.306c1.298,4.957,2.268,10.009,3.052,15.072 c0.049,0.318,0.098,0.636,0.144,0.954c0.023,0.161,0.195,0.307,0.345,0.345c9.001,2.255,17.985,5.268,26.396,9.185 c3.193,1.488,6.322,3.145,9.217,5.16C91.757,168.246,92.251,167.391,91.733,167.03L91.733,167.03z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#000000"
    },
    d: "M429.889,267.029c-0.978-13.647-2.706-27.208-4.519-40.764 c-1.594-11.917-2.737-23.903-3.462-35.905c-0.013-0.217-0.012-0.44-0.039-0.656c-0.007-0.054-0.266,0.326-0.063,0.151 c0.178-0.153,0.354-0.308,0.531-0.462c0.779-0.68,1.557-1.36,2.335-2.041c2.662-2.332,5.318-4.671,7.966-7.019 c5.949-5.276,11.961-10.525,17.624-16.111c1.198-1.182,2.553-2.331,3.116-3.958c0.955-2.759,1.417-5.739,1.911-8.606 c0.714-4.141,1.275-8.316,1.631-12.504c0.305-3.59,0.568-7.301,0.072-10.886c-0.21-1.518-0.733-4.392-2.858-4.093 c-2.381,0.335-3.64,3.798-4.388,5.675c-2.701,6.78-3.992,14.227-5.127,21.41c-0.052,0.331-0.184,0.736-0.165,1.073 c0.002,0.037-0.061,0.219-0.036,0.245c0.08,0.085,0.306-0.296,0.315-0.282c-0.053-0.081-1.556,0.409-1.665,0.439 c-3.19,0.865-6.357,1.821-9.497,2.852c-4.492,1.475-8.936,3.11-13.269,5.005c-4.272,1.868-8.533,3.977-12.277,6.781 c-1.455,1.09-2.831,2.287-3.991,3.691c-0.402,0.486,0.293,1.188,0.698,0.698c2.018-2.443,4.666-4.298,7.364-5.915 c3.262-1.954,6.717-3.583,10.22-5.053c6.096-2.557,12.389-4.658,18.743-6.475c1.314-0.376,2.632-0.745,3.958-1.078 c0.15-0.038,0.322-0.184,0.345-0.345c0.594-4.145,1.378-8.273,2.303-12.356c0.704-3.103,1.493-6.204,2.57-9.202 c0.683-1.901,1.557-4.683,3.334-5.885c3.115-2.106,2.675,8.414,2.629,9.552c-0.257,6.444-1.145,12.902-2.383,19.227 c-0.39,1.991-0.738,4.093-1.471,5.995c-0.423,1.098-1.418,1.93-2.229,2.745c-4.124,4.146-8.523,8.031-12.875,11.933 c-4.437,3.979-8.904,7.924-13.387,11.851c-0.849,0.743-2.121,1.516-2.789,2.436c-0.367,0.506-0.132,1.4-0.094,2.004 c0.097,1.536,0.202,3.071,0.313,4.606c0.756,10.413,1.801,20.801,3.19,31.149c1.379,10.271,2.713,20.547,3.67,30.867 c0.284,3.067,0.537,6.137,0.757,9.21C428.947,267.659,429.934,267.664,429.889,267.029L429.889,267.029z"
  }))))), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "rgb(0, 171, 101)",
      fontFamily: "'Segoe UI'",
      fontSize: 40,
      fontWeight: 700,
      whiteSpace: "pre"
    },
    transform: "matrix(1, 0, 0, 1, -32.701111, 1.552655)"
  }, _tspan || (_tspan = /*#__PURE__*/React.createElement("tspan", {
    x: 118.547,
    y: 472.245
  }, "No Pending Users")), _tspan2 || (_tspan2 = /*#__PURE__*/React.createElement("tspan", {
    x: 118.547,
    dy: "1em"
  }, "\u200B"))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoPendingUsers);
export default __webpack_public_path__ + "static/media/no-pending-users.027cc784690e6d7f4f008ef3c507ba92.svg";
export { ForwardRef as ReactComponent };